import React from 'react';
import styled from 'styled-components';
import NavLink from 'TMComponents/NavLink';
import Facebook from 'TMComponents/Icons/Facebook';
import Youtube from 'TMComponents/Icons/Youtube';
import Instagram from 'TMComponents/Icons/Instagram';
import Image from 'TMComponents/Image';
import { string, oneOf, shape } from 'prop-types';

const Link = styled(NavLink)`
    margin-left: -8px;
`;

const SocialMediaLink = ({
    link,
    company,
    size = 'md',
    icon,
    ariaLabel
}) => {
    const iconMap = {
        instagram: Instagram,
        facebook: Facebook,
        youtube: Youtube
    };

    const labelMap = {
        instagram: 'Visit our Instagram page',
        facebook: 'Visit our Facebook page',
        youtube: 'Visit our YouTube channel'
    };

    const label = ariaLabel || labelMap[company];
    const width = size === 'lg' ? 68 : 56;

    if (icon) {
        return (
            <Link href={link} aria-label={label}>
                <Image image={icon} alt={icon.alt || label} />
            </Link>
        );
    }

    const Icon = iconMap[company];
    if (!Icon) {
        return null;
    }
    return (
        <Link href={link} aria-label={label}>
            <Icon width={width} />
        </Link>
    );
};
SocialMediaLink.propTypes = {
    link: string.isRequired,
    company: string.isRequired,
    size: oneOf(['md', 'lg']),
    icon: shape({}),
    ariaLabel: string
};

export default SocialMediaLink;
